import { adminConfigApi } from '../apis';

class AdminConfigService {
  async getAdminConfig() {
    const rs = await adminConfigApi.getAdminConfig()
    return rs;
  }
}

const adminConfigService = new AdminConfigService();

export default adminConfigService;
